module.exports = __webpack_public_path__ + "img/tuxiang.5a943feb.png";